import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import {MatInputModule,
		MatIconModule,
		MatCardModule,
		MatButtonModule,
		MatListModule,
		MatGridListModule,
		MatProgressBarModule,
		MatMenuModule,
		MatButtonToggleModule,
		MatTabsModule,
		MatSelectModule,
		MatTableModule,
		MatRadioModule,
		MatToolbarModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { EditarObservacioneModalComponent } from './editar/editarobservacionemodal.component';
import { InsertarObservacioneModalComponent } from './insertar/insertarobservacionemodal.component';
@NgModule({
	declarations: [
		EditarObservacioneModalComponent,
		InsertarObservacioneModalComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatInputModule,
		MatIconModule,
		MatCardModule,
		MatButtonModule,
		MatListModule,
		ReactiveFormsModule,
		MatProgressBarModule,
		MatMenuModule,
		MatToolbarModule,
		FlexLayoutModule,
		MatButtonToggleModule,
		MatGridListModule,
		MatSelectModule,
		MatRadioModule,
		MatTabsModule,
		MatTableModule,
		NgxDatatableModule
	],
	entryComponents: [
		EditarObservacioneModalComponent,
		InsertarObservacioneModalComponent,
	]
})
export class ObservacionesModalModule {}
